import React from "react";

export const Image = ({ title, largeImage, smallImage, onSelect }) => {
  const handleClick = () => {
    if (onSelect) {
      onSelect({ title, largeImage, smallImage });
    }
  };

  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        <button
          onClick={handleClick}
          title={title}
          className="portfolio-button"
          aria-label={`View ${title} project`}
        >
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img src={smallImage} className="img-responsive" alt={title} />
        </button>
      </div>
    </div>
  );
};
